import { WidgetType } from "@/services/cloudchipr.api";

export const widgetsWhichHaveExplainWithAi: Set<WidgetType> = new Set([
  "cost_breakdown",
]);
